import { GRINDS, labelOf, type Subscription } from '@c214/shared';
import { Button } from '../ui/button';

export function ActiveSubscription({
  subscription,
  onSkip,
  onCancel,
  isSkipping,
  isCancelling,
}: {
  subscription: Subscription;
  onSkip: () => void;
  onCancel: () => void;
  isSkipping: boolean;
  isCancelling: boolean;
}) {
  return (
    <div className="mb-8 border border-accent p-6">
      <p className="mono-label mb-3 text-accent">АКТИВНА ПІДПИСКА</p>
      <p className="text-[16px] text-ink">
        {subscription.productName} · {subscription.qty} × 250 г ·{' '}
        {labelOf(GRINDS, subscription.grind)}
      </p>
      <p className="mono-label mt-3">
        НАСТУПНА ДОСТАВКА: {new Date(subscription.nextDeliveryAt).toLocaleDateString('uk-UA')}
      </p>
      <div className="mt-4 flex gap-3">
        <Button variant="secondary" size="sm" onClick={onSkip} disabled={isSkipping}>
          ПРОПУСТИТИ
        </Button>
        <Button variant="ghost" size="sm" onClick={onCancel} disabled={isCancelling}>
          СКАСУВАТИ
        </Button>
      </div>
    </div>
  );
}
